import React from 'react'

class ErrorBoundary extends React.Component {
  state = { hasError: false, errorMessage: '' }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, errorMessage: error.message || 'Undefined error' })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <p>An unexpected error happened</p>

          <div>
            <p>We've been notified and are working on it!</p>
          </div>

          <p>
            <span>Message: {this.state.errorMessage}</span>
          </p>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
